import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import ButtonTag from '@components/framework/tags/ButtonTag.tsx';
import SvgYellowExclamation from '@components/ringil3/icons/YellowExclamation';
import RingilTextArea from '@components/framework/input/RingilTextArea';
import SvgTagEdit from '@components/ringil3/icons/TagEdit';
import { SecuredConfig } from '@components/security/securedDecoration';

interface ComponentProps {
  reservationName: string;
  onChange: (reservationName: string) => void;
  readOnly?: boolean;
  dataTestId?: string;
  secured?: SecuredConfig;
}

const ReservationNameTag: React.FC<ComponentProps> = ({ reservationName, onChange, readOnly, dataTestId, secured }) => {
  const { tr } = useTranslationLgs();
  const [internalReservationName, setInternalReservationName] = useState(reservationName);
  const [open, setOpen] = useState(false);

  const actionPane = () => {
    return (
      <>
        <RingilTextArea
          rows={1}
          value={internalReservationName}
          onChange={v => setInternalReservationName(v)}
          maxLength={255}
          className={'resize-none'}
        />
      </>
    );
  };

  return (
    <>
      <ButtonTag
        label={tr(`ReservationNameTag.title`, `Reservation name`)}
        value={reservationName}
        icon={<SvgYellowExclamation fill={'var(--content-secondary)'} />}
        actionPane={actionPane()}
        actionIcon={<SvgTagEdit />}
        onSave={() => {
          setOpen(false);
          onChange(internalReservationName);
        }}
        readonly={readOnly}
        dataTestId={dataTestId}
        secured={secured}
      />
    </>
  );
};

export default ReservationNameTag;
